import { ContainerPointsResource, containerPointsResource } from '@witkac/kartamiejska-resources';
import { ContainerPoints } from '@witkac/kartamiejska-shared';

import { EntityListModule } from './entityList.module';

/**
 * Moduł kontenerów na punkty
 *
 * @class ContainerPointsModule
 * @extends {EntityListModule<ContainerPoints, ContainerPointsResource>}
 */
class ContainerPointsModule extends EntityListModule<ContainerPoints, ContainerPointsResource> {}

export default new ContainerPointsModule(containerPointsResource);
